import { render, staticRenderFns } from "./PieChartViewer.vue?vue&type=template&id=0eabd7f9&scoped=true&"
import script from "./PieChartViewer.vue?vue&type=script&lang=js&"
export * from "./PieChartViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eabd7f9",
  null
  
)

export default component.exports